import { MutationTree } from 'vuex'

import { SlogState } from '@/types/store'
import { ISlog } from '@/types/slog'

export const mutations: MutationTree<SlogState> = {
  setIsLogsLoading(state, isLogsLoading: boolean) {
    state.isLogsLoading = isLogsLoading
  },
  logsLoaded(state, logs: ISlog[]) {
    state.logs = logs
  },
}
